import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID
} from '@angular/core';
import { componentDestroyed, handleError, LeagueNews, UntilDestroy } from '@mtgame/core';
import { getLeagueVideoDetailRoute, getLeagueVideoListRoute } from '@config/routes';
import { LeagueVideoService } from './league-video.service';
import { isPlatformBrowser } from '@angular/common';
import { takeUntil } from 'rxjs/operators';
import { LoaderService } from '@mtgame/ui';

@UntilDestroy
@Component({
  selector: 'mtg-league-video',
  templateUrl: './league-video.component.html',
  styleUrls: [
    '../shared/styles.scss',
    './league-video.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    LeagueVideoService
  ]
})
export class LeagueVideoComponent implements OnInit, OnDestroy {
  videos: LeagueNews[];

  constructor(
    @Inject(PLATFORM_ID) private platformId: string,
    private leagueVideoService: LeagueVideoService,
    private cdr: ChangeDetectorRef,
    private loaderService: LoaderService,
  ) {
  }

  ngOnInit(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.leagueVideoService.videos$
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(videos => {
        this.videos = videos;
        this.cdr.markForCheck();
      });
    this.leagueVideoService.initialize();
  }

  ngOnDestroy(): void {
  }

  async loadNextPage(): Promise<void> {
    this.loaderService.show();
    try {
      await this.leagueVideoService.loadNextPage();
    } catch (e) {
      handleError(e);
    } finally {
      this.loaderService.hide();
    }
  }

  getVideoListRoute(): string[] {
    return getLeagueVideoListRoute();
  }

  getVideoDetailRoute(videoId: number): string[] {
    return getLeagueVideoDetailRoute(videoId);
  }
}
